import { authRoles } from 'app/auth';
import React from 'react';
import { Redirect } from 'react-router-dom';

const DashboardsConfig = {
  settings: {
    layout: {}
  },
  routes: [
    {
      path: '/data-center',
      component: React.lazy(() => import('./DataCenter')),
      auth: authRoles.dataCenter
    },
    {
      path: '/dashboards/analytics',
      component: () => <Redirect to="/data-center" />
    },
    {
      path: '/dashboards/monthly-chart',
      component: () => <Redirect to="/data-center" />
    }
  ]
};

export default DashboardsConfig;
